
import React from "react";
import { Reagent } from "@/types/reagent.types";
import SwapFormHeader from "./SwapFormHeader";
import OfferTypeTabs from "./OfferTypeTabs";
import MessageField from "./MessageField";
import SwapFormActions from "./SwapFormActions";
import { useSwapRequestForm } from "@/hooks/useSwapRequestForm";

interface SwapRequestFormProps {
  reagent: Reagent;
}

const SwapRequestForm: React.FC<SwapRequestFormProps> = ({ reagent }) => {
  const {
    offerType,
    setOfferType,
    message,
    setMessage,
    creditAmount,
    setCreditAmount,
    userReagents,
    selectedReagentId,
    setSelectedReagentId,
    isLoadingReagents,
    insufficientCredits,
    isSubmitting,
    handleSubmit,
    profile
  } = useSwapRequestForm(reagent);
  
  const handleTabChange = (value: string) => {
    setOfferType(value as "reagent" | "credits");
  };
  
  // Get reagent owner's username from the profiles object or fall back to userName
  const reagentOwnerName = 
    (reagent.profiles && (reagent.profiles.display_username || reagent.profiles.username)) || 
    reagent.userName || 
    "the reagent owner";
  
  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <SwapFormHeader 
        reagent={reagent} 
        profile={profile} 
      />
      
      <OfferTypeTabs
        offerType={offerType}
        onValueChange={handleTabChange}
        creditAmount={creditAmount}
        setCreditAmount={setCreditAmount}
        userReagents={userReagents}
        selectedReagentId={selectedReagentId}
        setSelectedReagentId={setSelectedReagentId}
        isLoadingReagents={isLoadingReagents}
        insufficientCredits={insufficientCredits}
        creditBalance={profile?.credit_balance}
      />
      
      <MessageField 
        message={message} 
        setMessage={setMessage} 
        reagentOwner={reagentOwnerName} 
      />
      
      <SwapFormActions
        isSubmitting={isSubmitting}
        insufficientCredits={insufficientCredits}
        reagentId={reagent.id}
        onSubmit={handleSubmit}
      />
    </form>
  );
};

export default SwapRequestForm;
